{
  "bumps": {"major": "Hauptversion", "minor": "Nebenversion", "patch": "Korrekturversion"},
  "confirmed": {"bump": "{{subject}}: {{bump}}", "changeLine": "Änderungszeile: {{line}}"},
  "contentVersions": {
    "loading": "Inhaltsversionen werden gelesen …",
    "none": "Keine Inhaltsversion hat geändert, was dieses Prozessschema liest."
  },
  "corpus": "Korpus",
  "edit": {
    "derive": "Als abgeleitetes Prozessschema von {{workflow}} {{version}} speichern",
    "deriveUnlabelled": "Als abgeleitetes Prozessschema von {{workflow}} speichern",
    "loading": "Es wird gelesen, wie dieses Prozessschema geändert werden kann …",
    "unavailable": {
      "library": "Dieses Prozessschema stammt aus einer Bibliothek, die es aktualisiert. Speichern Sie Ihre Änderung als abgeleitetes Prozessschema."
    },
    "update": "{{workflow}} auf {{version}} aktualisieren",
    "updateUnlabelled": "{{workflow}} aktualisieren"
  },
  "label": "{{name}} {{version}}",
  "merge": {
    "bumpFor": "Versionsänderung für {{subject}}",
    "bumpGives": "{{bump}} → {{version}}",
    "changeLine": "Änderungszeile, die bei den neuen Versionen steht",
    "draft": "Entwurf auf Basis von {{current}} · schlägt {{proposed}} vor",
    "loading": "Vorgeschlagene Versionen werden gelesen …",
    "mayChangeMethod": "Hauptversion, wenn es ändert, was der Schritt tut",
    "new": "Neu: beginnt bei 1.0.0",
    "planFailed": "Ohne den Vorschlag verwendet DMW bei der Übernahme seine vorgeschlagenen Versionen unbestätigt.",
    "proposedBump": "{{bump}} (vorgeschlagen)",
    "removed": "Entfernt: erhält keine neue Version",
    "title": "Versionen",
    "unchanged": "Bleibt bei {{current}}"
  },
  "projectContent": "Projektinhalt",
  "reasons": {
    "content_changed": "Inhalt geändert",
    "documents_added": "Dokumente hinzugefügt",
    "documents_changed": "Dokumente geändert",
    "documents_removed": "Dokumente entfernt",
    "editorial": "nur Formulierungen",
    "graph_changed": "zwischen Datenmodell und Prozessontologie verschoben",
    "inputs_accept_less": "Eingaben nehmen weniger an",
    "inputs_added": "optionale Eingaben hinzugefügt",
    "inputs_became_required": "Eingaben sind jetzt Pflicht",
    "inputs_removed": "Eingaben entfernt",
    "items_added": "Elemente hinzugefügt",
    "items_removed": "Elemente entfernt",
    "label_terms_changed": "Begriffe der Labels geändert",
    "labels_added": "Labels hinzugefügt",
    "labels_changed": "Labels geändert",
    "labels_removed": "Labels entfernt",
    "lifecycle_changed": "Lebenszyklus geändert",
    "outputs_added": "Ausgaben hinzugefügt",
    "outputs_changed_kind": "Art der Ausgaben geändert",
    "outputs_removed": "Ausgaben entfernt",
    "placeholders_changed": "Platzhalter geändert",
    "prompt_text_changed": "Prompttext geändert",
    "required_inputs_added": "Pflichteingaben hinzugefügt",
    "retired": "stillgelegt",
    "shapes_added": "Shapes hinzugefügt",
    "shapes_changed": "Shapes geändert",
    "statements_changed": "andere Aussagen geändert",
    "step_kind_changed": "Art des Schritts geändert",
    "step_method_changed": "Methode eines Schritts geändert",
    "step_prompt_changed": "Prompt eines Schritts geändert",
    "step_tool_changed": "Werkzeug eines Schritts geändert",
    "step_versions_changed": "Schrittversionen geändert",
    "steps_added": "Schritte hinzugefügt",
    "steps_removed": "Schritte entfernt",
    "steps_reordered": "Schritte umgeordnet",
    "steps_replaced": "Schritte ersetzt",
    "term_hierarchy_changed": "Begriffshierarchie geändert",
    "term_signatures_changed": "Definitions- oder Wertebereiche von Begriffen geändert",
    "terms_added": "Begriffe hinzugefügt",
    "terms_removed": "Begriffe entfernt",
    "terms_renamed": "Begriffe umbenannt",
    "tool_code_changed": "Code des Werkzeugs geändert",
    "tool_interface_changed": "Schnittstelle des Werkzeugs geändert",
    "wiring_changed": "Verbindungen zwischen Schritten geändert"
  },
  "unlabelled": "Keine Versionsbezeichnung"
}
